import InsightList from './insightList';

export default InsightList;
